export default function apiUrl() {
  return process.env.VUE_APP_BACKEND_URL
}
